import React from 'react';
import { SCol, SRow, SIcon } from '@avalara/skylab-sdk/react';
import styled from 'styled-components';
const UnstyledList = styled.ul `list-style-type: none;`;
const IncludedItemsBreakdown = ({ planIncludes, offerFlow }) => (!planIncludes ? null : React.createElement(SRow, null,
    React.createElement(SCol, null,
        React.createElement("p", { className: 'font-italic smaller-text' }, planIncludes.heading),
        React.createElement(UnstyledList, { className: 'margin-left-md margin-bottom-md' }, planIncludes.items.map((item, i) => React.createElement("li", { key: i, className: 'font-italic smaller-text', "data-ref": `${offerFlow || ''}-total-plan-includes-${i}` },
            React.createElement(SIcon, { name: 'check', role: 'img', className: 'pad-right-xs', "aria-label": '' }),
            item))))));
export default IncludedItemsBreakdown;
